import { render, staticRenderFns } from "./Subtest.vue?vue&type=template&id=1ba2119b&scoped=true"
import script from "./Subtest.vue?vue&type=script&lang=js"
export * from "./Subtest.vue?vue&type=script&lang=js"
import style0 from "./Subtest.vue?vue&type=style&index=0&id=1ba2119b&prod&lang=css&scoped=true"
import style1 from "./Subtest.vue?vue&type=style&index=1&id=1ba2119b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2119b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
